import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { alertsOccurSelector, alertsResSelector } from '../selectors';
import { fetchAlertData } from '../actions/entry';
import Alerts from '../components/Alerts';

const mapStateToProps = (state) => {
  const alertsOccur = alertsOccurSelector(state).sort(
    (dateA, dateB) => new Date(dateB.createdAt) - new Date(dateA.createdAt),
  );
  const alertsRes = alertsResSelector(state).sort(
    (dateA, dateB) => new Date(dateB.updatedAt) - new Date(dateA.updatedAt),
  );

  return {
    alertsOccur,
    alertsRes,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchAlertData: (alertId, data) => fetchAlertData(alertId, data),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
